<template>
	<CbsCommentGeneral
		v-bind="$attrs"
		:limit="limit"
		:displayMode="displayMode"
		:commentData="commentData"
		@sendComment="sendComment"
		@loadMoreComments="loadMoreComments"
	/>
</template>

<script>
import commentGQL from "@/http/requests/inside/comment_gql";

import CbsCommentGeneral from "@/components/cbs-comment-general/CbsCommentGeneral";

export default {
	name: "CbsComment",
	inheritAttrs: false,
	components: { CbsCommentGeneral },
	props: {
		postId: {
			type: Number,
			required: true
		},
		model: {
			type: String,
			required: true
		},
		limit: {
			type: Number,
			default: 5
		},
		displayMode: {
			type: String,
			validator: prop => ["chat", "post-comments"].includes(prop),
			default: "chat"
		}
	},
	emits: {
		onSentComment: {}
	},
	data() {
		return {
			commentData: {
				data: [],
				total: 0,
				has_more_pages: null
			}
		};
	},
	methods: {
		async getInitCommentData() {
			try {
				this.$vs.loading();
				this.commentData = await commentGQL.getComments({
					page: 1,
					model: this.model,
					limit: this.limit,
					post_id: this.postId
				});

			} catch (error) {
				this.$helper.notifyError({ context: this, error });
			} finally {
				this.$nextTick(() => this.$vs.loading.close());
			}
		},
		sendComment(comment, resolve, reject) {
			commentGQL
				.addComment({
					content: comment,
					model: this.model,
					post_id: this.postId
				})
				.then(response => {
					this.commentData = Object.assign({}, {
						...this.commentData,
						data: [response, ...this.commentData.data],
						total: (this.commentData.total += 1)
					});

					resolve(response);
					this.$emit("onSentComment", this.commentData);
				})
				.catch(error => {
					reject(error);
				});
		},
		loadMoreComments(commentsPage, commentsLimit, resolve, reject) {
			commentGQL
				.getComments({
					model: this.model,
					page: commentsPage,
					limit: commentsLimit,
					post_id: this.postId
				})
				.then(response => {
					this.commentData = Object.assign({}, {
						...response,
						data: [...this.commentData.data, ...response.data]
					});

					resolve(response);
				})
				.catch(error => {
					reject(error);
				});
		}
	},
	created() {
		this.getInitCommentData();
	}
};
</script>
